// anzeigeBeispiele.js — Beispieldaten für die Vorschau der Hallenbildschirme
// (Modus-Übersicht, Reiter „Anzeige / Display“, und ?vorschau=1 auf
// /display/:matte und /formen-display). Erfundene Namen, keine echten
// Personen, keine Fotos (nur das Logo). Gerechnet wird nichts: Summen und
// Streichung stehen fest drin, wie sie formenScoring.js liefern würde
// (fünf Kampfrichter, höchste und niedrigste Note gestrichen).

/** Mattenzustand wie mat-state + tafel-update (pages/MatDisplay.jsx). */
export const BEISPIEL_KAMPF = {
  status: 'active',
  session_typ: 'kumite',
  rote_punkte: 5, blaue_punkte: 3,
  rote_warnings: 1, blaue_warnings: 0,
  rote_minus: 0, blaue_minus: 0,
  timer_remaining: 74, timer_seconds: 120, timer_running: true,
  kata_notes: {}, bruchtest_rot_scores: [], bruchtest_blau_scores: [],
  fight_info: {
    rot: 'Lena Berger', blau: 'Mia Hoffmann',
    division_code: 'PF-J-52', division_name: 'Pointfighting Jugend −52 kg',
  },
  tafel: {
    runde: 'Halbfinale',
    disziplin: 'Pointfighting',
    kategorie: 'Jugend −52 kg',
    rot: { verein: 'Kampfsport Nord', bild: '/logo.png', bild_art: 'logo' },
    blau: { verein: 'Budo Süd', bild: '/logo.png', bild_art: 'logo' },
    turnier: { name: 'Beispiel-Cup', logo: '/logo.png', veranstalter: 'Beispielverband' },
    naechster: { kategorie: 'Jugend −57 kg', runde: 'Viertelfinale', rot: 'Jana Wolf', blau: 'Sara König' },
  },
};

const RANGLISTE = [
  { wettkaempfer_id: 9001, vorname: 'Hana', nachname: 'Sato', verein_name: 'Dojo Ost', gesamt_punkte: 24.6, status: 'completed', platzierung: 1 },
  { wettkaempfer_id: 9002, vorname: 'Emma', nachname: 'Krüger', verein_name: 'Kampfsport Nord', gesamt_punkte: 24.3, status: 'completed', platzierung: 2 },
  { wettkaempfer_id: 9003, vorname: 'Lea', nachname: 'Fischer', verein_name: 'Budo Süd', gesamt_punkte: 23.9, status: 'completed', platzierung: 3 },
  { wettkaempfer_id: 9004, vorname: 'Nina', nachname: 'Wagner', verein_name: 'Dojo West', gesamt_punkte: 23.4, status: 'completed', platzierung: 4 },
];

/** Leinwand-Paket „wertung“ wie FormenSchreiberDashboard es sendet. */
export const BEISPIEL_KATA = {
  typ: 'wertung',
  disziplin: 'formen',
  kategorie: 'Formen Jugend weiblich',
  turnier: 'Beispiel-Cup',
  logo: '/logo.png',
  teilnehmer: {
    wettkaempfer_id: 9002, startnummer: 12, vorname: 'Emma', nachname: 'Krüger',
    verein_name: 'Kampfsport Nord', gurtfarbe: 'Blau', foto_frei: false, verein_logo: null, form_name: 'Bassai Dai',
  },
  wertungen: [
    { kampfrichter_nummer: 1, punkte: 8.1, eingegangen: true },
    { kampfrichter_nummer: 2, punkte: 8.3, eingegangen: true },
    { kampfrichter_nummer: 3, punkte: 7.9, eingegangen: true },
    { kampfrichter_nummer: 4, punkte: 8.5, eingegangen: true },
    { kampfrichter_nummer: 5, punkte: 7.6, eingegangen: true },
  ],
  scoring: {
    gesamt_punkte: 24.3, gestrichen: [4, 5], vollstaendig: true,
    gross_label: '合計 GESAMT', unterzeile: 'aus 3 von 5 Wertungen · höchste und niedrigste gestrichen',
  },
  rangliste: RANGLISTE,
  starter: RANGLISTE.map((r, i) => ({ wettkaempfer_id: r.wettkaempfer_id, startnummer: 10 + i, vorname: r.vorname, nachname: r.nachname, status: 'completed', gesamt_punkte: r.gesamt_punkte })),
  folgende: [{ wettkaempfer_id: 9005, startnummer: 15, vorname: 'Sophie', nachname: 'Lange', verein_name: 'Dojo Ost' }],
  fortschritt: { position: 4, gesamt: 6 },
  platzierung: 2,
  gespeichert: true,
};

/** Kategorie für die Siegerbühne (components/leinwand/SiegerBuehne). */
export const BEISPIEL_SIEGER = {
  kategorie_name: 'Formen Jugend weiblich',
  division_type: 'Formen',
  plaetze: RANGLISTE.map((r) => ({
    platzierung: r.platzierung, wettkaempfer_id: r.wettkaempfer_id, vorname: r.vorname, nachname: r.nachname,
    verein_name: r.verein_name, punkte: r.gesamt_punkte, foto_frei: false, verein_logo: null,
  })),
};

// Turnierbaum: acht Starter, K.-o. mit Kampf um Platz 3, Halbfinale läuft
const NAMEN = [
  ['Lena', 'Berger', 'Kampfsport Nord'], ['Mia', 'Hoffmann', 'Budo Süd'], ['Jana', 'Wolf', 'Dojo Ost'], ['Sara', 'König', 'Dojo West'],
  ['Lara', 'Schmid', 'Kampfsport Nord'], ['Anna', 'Huber', 'Budo Süd'], ['Clara', 'Becker', 'Dojo Ost'], ['Ella', 'Roth', 'Dojo West'],
];
export const BEISPIEL_BAUM_TEILNEHMER = NAMEN.map(([vorname, nachname, verein_name], i) => ({
  wettkaempfer_id: 9101 + i, vorname, nachname, verein_name, seed_position: i + 1, foto: null, verein_logo: null,
}));
const id = (n) => 9100 + n;
const kampf = (kampf_id, runde, kampf_nummer, a, b, sieger, extra = {}) => ({
  kampf_id, bracket_id: 990, runde, kampf_nummer, kaempfer1_id: a, kaempfer2_id: b,
  gewinner_id: sieger, status: sieger ? 'completed' : 'pending', bracket_typ: 'winners', ist_trostrunde: 0,
  punkte_kaempfer1: sieger ? (sieger === a ? 6 : 2) : null, punkte_kaempfer2: sieger ? (sieger === b ? 6 : 2) : null, ...extra,
});
export const BEISPIEL_BAUM_KAEMPFE = [
  kampf(1, 1, 1, id(1), id(8), id(1)),
  kampf(2, 1, 2, id(4), id(5), id(5)),
  kampf(3, 1, 3, id(3), id(6), id(3)),
  kampf(4, 1, 4, id(2), id(7), id(2)),
  kampf(5, 2, 1, id(1), id(5), id(1)),
  kampf(6, 2, 2, id(3), id(2), null),
  kampf(7, 3, 1, id(1), null, null),
  kampf(8, 1, 99, id(5), null, null, { bracket_typ: 'losers', ist_trostrunde: 1 }),
];
export const BEISPIEL_BAUM_KATEGORIE = 'Pointfighting Jugend −52 kg';
